import React from 'react'
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import PicCont from '../components/PicCont';
import SimilarCats from '../components/SimilarCats';
import BGBlock from '../components/BGBlock';
import ProductList from '../components/ProductList';
import { useDispatch, useSelector } from 'react-redux';
import { wrapper } from '../store/configStore';
import { SERVER_IP } from '../store/middleware/api';
import axios from 'axios';
import ClientReviews from '../components/ClientReviews';
import PastEvents from '../components/PastEvents';
import NotSure from '../components/NotSure';
import LandingCategories from '../components/LandingCategories';
import { getFilteredProducts, productsReceived, productsSetFilters } from '../store/slices/entities/products';
import karaokeHeroV2 from '../public/Pictures/categories-v2/karaoke-rental-hero-v2.jpg'
import machine from '../public/Pictures/karaoke-machine.jpg'
import karaoketop from '../public/Pictures/karaokemachine.jpg'
import { GiBigDiamondRing } from "@react-icons/all-files/gi/GiBigDiamondRing";
import { BsFillBriefcaseFill } from "@react-icons/all-files/bs/BsFillBriefcaseFill";
import { FaBirthdayCake } from "@react-icons/all-files/fa/FaBirthdayCake";
import { FaSchool } from "@react-icons/all-files/fa/FaSchool";
import { FaRegCalendarCheck } from "@react-icons/all-files/fa/FaRegCalendarCheck";
import { GiPartyFlags } from "@react-icons/all-files/gi/GiPartyFlags";
import { BiDrink } from "@react-icons/all-files/bi/BiDrink";
import { BiRestaurant } from "@react-icons/all-files/bi/BiRestaurant";
import { GiPartyPopper } from "@react-icons/all-files/gi/GiPartyPopper";
import { MdGroup } from "@react-icons/all-files/md/MdGroup";
import { AiOutlineFullscreen } from "@react-icons/all-files/ai/AiOutlineFullscreen";
import { FaMicrophoneAlt } from "@react-icons/all-files/fa/FaMicrophoneAlt";
import PageShell from '../components/design-system/foundations/PageShell';
import ServiceHero from '../components/design-system/marketing/ServiceHero';
import AudioClosingActionBand from '../components/design-system/marketing/AudioClosingActionBand';
import ServiceOverview from '../components/design-system/marketing/ServiceOverview';
import RentalFAQV2 from '../components/design-system/marketing/RentalFAQV2';
import QuotePop from '../components/DeferredQuotePopup';
import { SHOW_POPUP } from '../store/slices/ui';
import { FiMessageCircle } from '@react-icons/all-files/fi/FiMessageCircle';
import { FiMic } from '@react-icons/all-files/fi/FiMic';
import * as gtag from '../lib/gtag';
import { compactCatalogProducts } from '../utilities/catalogPublicPayload';
import { compactPublicEvents } from '../utilities/eventPublicPayload';
import { getAudioFamilyBreadcrumbs, toBreadcrumbJsonLdItems, toHeroBreadcrumbs } from '../utilities/audioFamilyBreadcrumbs';

const karaokeOverviewContent = {
    id: 'karaoke-rental-overview',
    heading: 'Looking to Rent a Karaoke Machine for your Party in Miami?',
    body: [
        'Choose from a variety of karaoke equipment rental bundles to elevate your Miami or South Florida event.',
        'We also provide karaoke rental packages for special events such as weddings, graduations, and fashion shows. If you want to rent a karaoke machine or just speakers and microphones for karaoke, don\'t hesitate to contact one of our representatives.'
    ],
    guide: {
        heading: 'Enhance your celebration with our karaoke systems!',
        summary: 'From intimate gatherings to major occasions like weddings and corporate events, our karaoke machine rentals services promise an unforgettable experience.',
        body: [
            <p key='filters'>Select the perfect Karaoke Package sorting by <strong>Event Size</strong> (number of attendees), <strong>Screen Size</strong>, <strong>Number of Wireless / Wired Microphones</strong>, <strong>Price</strong>, and more.</p>,
            <p key='process'>Once you&apos;ve made your choice, select <strong>&quot;Choose Dates &amp; Rent Online&quot;</strong>. You can then choose warehouse pickup or delivery and setup before entering the dates needed to show real availability.</p>
        ]
    },
    media: { src: karaoketop, alt: '' }
}

const karaokeFeaturesContent = {
    id: 'karaoke-rental-features',
    heading: 'What kind of events can be made better with karaoke?',
    body: (
        <ul>
            <li>Weddings</li>
            <li>Corporate Parties</li>
            <li>Birthday Parties</li>
            <li>Bar Mitzvahs</li>
            <li>School Events</li>
            <li>Anniversary Celebrations</li>
            <li>Family Reunions &amp; Events</li>
            <li>Bachelor &amp; Bachelorette Parties</li>
        </ul>
    ),
    guide: {
        heading: 'Ready-to-sing Karaoke Machines',
        body: (
            <ul>
                <li>Over 70,000 karaoke songs to choose to feel like a Rock Star.</li>
                <li>10+ languages.</li>
                <li>Includes a fully configured and ready-to-use iPad or laptop. Just tap SING to start your karaoke party!</li>
                <li>Remote control, vocal volume control, on-screen selfies, and more.</li>
                <li>Every bundle includes 1 to 4 professional wireless microphones and powered loud JBL speakers.</li>
                <li>Choose a set with a TV or projector and a screen if necessary.</li>
            </ul>
        )
    },
    media: { src: machine, alt: '' }
}



export const getStaticProps = wrapper.getStaticProps(
    async ({ store, preview }) => {
        const corp = await axios.request(`${SERVER_IP}/user/static-landing`)
        const subCate = await axios.request(`${SERVER_IP}/subcategory/name/karaoke?cat=sound`)
        const products = await axios.request(`${SERVER_IP}/inventory/product?msr=true&cat=Karaoke`)
             const faq = await axios.request(`${SERVER_IP}/faq?category=Karaoke`)
        store.dispatch({ type: productsReceived.type, payload: compactCatalogProducts(products.data) })
        store.dispatch({ type: productsSetFilters.type, payload: { static: true } })
        let { newsletterevents, total_events } = corp?.data
        return {
            props: {
                newsletterevents: compactPublicEvents(newsletterevents), total_events, subCate: subCate.data, faq: faq.data
            }
        }
    }
);


const KaraokeRental = ({ newsletterevents, total_events, subCate, faq }) => {
    let products = useSelector(getFilteredProducts)
    const dispatch = useDispatch()
    const openQuote = () => {
        gtag.event({ action: 'quote_click', label: 'leads', value: 3, category: 'orders' })
        dispatch(SHOW_POPUP({
            key: 'quote',
            size: 'medium',
            body: <QuotePop />
        }))
    }
    const heroSteps = [
        { icon: 'search', title: 'Choose your package', description: 'Compare microphones, screens, speakers, and guest capacity.' },
        { icon: 'calendar', title: 'Select dates', description: 'Tell us when you need it.' },
        { icon: 'truck', title: 'Pickup or delivery', description: 'Collect it or schedule professional delivery and setup.' },
        { icon: 'success', title: 'Start singing', description: 'Enjoy a ready-to-use karaoke system with local support.' }
    ]
    const primaryHeroAction = {
        label: 'Browse Karaoke Packages',
        href: '#productsAnchor',
        icon: FiMic,
        conversionKey: 'karaoke-rental.hero.browse-packages',
        channel: 'rental',
        salesPath: 'self_service',
        onClick: () => gtag.event({
            action: 'catalog_click',
            label: 'leads',
            value: 2,
            category: 'orders'
        })
    }
    const secondaryHeroAction = {
        label: 'Talk to an Expert',
        icon: FiMessageCircle,
        conversionKey: 'karaoke-rental.hero.talk-to-expert',
        channel: 'quote',
        salesPath: 'managed',
        onClick: openQuote
    }
    const breadcrumbs = getAudioFamilyBreadcrumbs('/karaoke-rental')
    return <>
           <BreadcrumbJsonLd
        itemListElements={toBreadcrumbJsonLdItems(breadcrumbs)}
      />
        <NextSeo
            title='Karaoke Machine Rental from $335 in Miami & Fort Lauderdale'
            description='Rent karaoke equipment for your event such as a party or wedding. Karaoke rental packages include a laptop with 70000+ studio songs. Available 24/7 for pick up or delivery.'
            canonical="https://miamisoundrental.com/karaoke-rental"
            twitter={{
                handle: '@miamisoundrent1',
                site: '@miamisoundrent1',
                cardType: 'summary_large_image',
            }}
            openGraph={{
                type: 'website',
                url: `https://miamisoundrental.com/karaoke-rental`,
                title: 'Karaoke Machine Rental from $335 in Miami & Fort Lauderdale',
                description: 'Rent karaoke equipment for your event such as a party or wedding. Karaoke rental packages include a laptop with 70000+ studio songs. Available 24/7 for pick up or delivery.',
                images: [
                    {
                        url: 'https://miamisoundrental.com/Pictures/categories-v2/karaoke-rental-hero-v2.jpg',
                        width: 1915,
                        height: 821,
                        alt: 'Professional karaoke rental setup with microphones, screen, and speaker in Miami',
                    },
                ],
                site_name: 'Miami Sound Rental',
            }}
        />
        <div className='categoryRental karaokeRental'>
            <PageShell>
                <ServiceHero
                    breadcrumbs={toHeroBreadcrumbs(breadcrumbs)}
                    eyebrow='Karaoke rental · Miami & Fort Lauderdale'
                    title='Karaoke Machine Rental'
                    description='Explore our selection of professional karaoke equipment rentals in Miami, from small parties to large events.'
                    image={{ src: karaokeHeroV2, position: 'center' }}
                    imageAlt='Professional karaoke rental setup with microphones, screen, and speaker in Miami'
                    primaryAction={primaryHeroAction}
                    secondaryAction={secondaryHeroAction}
                    processLabel='How karaoke rental works'
                    steps={heroSteps}
                />
            </PageShell>
            <PageShell>
                <ServiceOverview content={karaokeOverviewContent} />
            </PageShell>

 
    
            <section className='stageType white'>           
       
                <ProductList 
                     carousel={{
                    name: 'Karaoke Rentals',
                    url: 'https://miamisoundrental.com/karaoke-rental',
                    description: 'Karaoke bundles, karaoke machines, speakers and screens'
                }}
                sortBy={{      
    'Event Size': ['green', <MdGroup key='group' style={{color: 'green'}}  />],
    'Screen Size': ['darkGoldenRod', <AiOutlineFullscreen key='group' style={{color: 'darkGoldenRod'}}  />],
    'Microphones': ['darkSlateBlue', <FaMicrophoneAlt key='group' style={{color: 'darkSlateBlue'}}  />],
    }}  listName='Karaoke Bundles' anchor products={products.filter(p => p.categories?.includes('Sound/Karaoke'))} />
                <NotSure />
            </section>

            <section className='stageType'>
            
       
            <LandingCategories ui='v2' loading='lazy' className='padBottom' title options category='sound' />
            <PageShell>
                <ServiceOverview content={karaokeFeaturesContent} />
            </PageShell>
          
            </section>
           <RentalFAQV2 questions={faq} headingId='karaoke-rental-faq-title' />
            <SimilarCats
                ui='v2'
                subCate={subCate}
                heading='Build your own Karaoke System'
                description='You can also choose individual item rentals from the following categories:'
            />
        
            <PastEvents ui='v2' filter={['party', 'private', 'presentation']} newsletterevents={newsletterevents} total_events={total_events} />
            <ClientReviews
                ui='v2'
                filter={['party']}
                heading='Recent feedback from party and private-event clients'
            />
            <PageShell>
                <AudioClosingActionBand
                    pagePath='/karaoke-rental'
                    primaryAction={primaryHeroAction}
                    secondaryAction={secondaryHeroAction}
                />
            </PageShell>
        </div>
    </>
}

export default KaraokeRental
